<template>
  <div class="summary-box">
    <h3 class="summary-box-title" v-if="title">{{ title }}</h3>
    <div
      v-for="({ label, value }, index) in listItems"
      :key="`${value}-${index}`"
      :title="value"
      :class="getContentClass(index)"
    >
      <p>{{ label }}</p>
      <p>{{ value }}</p>
    </div>
    <div v-if="summaryItem" class="summary-box-footer">
      <h3 class="summary-box-title">{{ summaryItem.label }}</h3>
      <p v-html="summaryItem.value"></p>
      <p v-if="footerText">{{ footerText }}</p>
    </div>
  </div>
</template>
<script>
import classnames from "classnames";

export default {
  name: "summary-box",
  props: {
    title: {
      type: String,
    },
    summaryItem: {
      type: Object,
    },
    footerText: {
      type: String,
    },
    listItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    getContentClass(index) {
      const className = "summary-box-content";

      return classnames(className, {
        ["bold"]: index === this.listItems.length - 1,
      });
    },
  },
};
</script>
